import { Scene } from "./Scene";
import Button from '@mui/material/Button';

export function PlayButton({ scenes, setScenes }) {
  const handleSubmit = (event) => {
    // prevent the form reloading the page
    event.preventDefault();
    // implementation details
    let scName = document.getElementById("sceneName").value;
    if (scName === "") {
      alert("Scene Name must be provided");
      return;
    }
    document.getElementById("sceneName").value = "";
    setScenes((scenes) => [...scenes, <Scene sceneName={scName} setScenes={setScenes}/>]);
  };

  //Load yt api script before creating tracks
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  const hasScenes = scenes.length > 0;

  return (
    <div>
      <form onSubmit={handleSubmit} className={`create-scene-form ${hasScenes ? 'compact' : ''}`}>
        <label htmlFor="sceneName">Scene Name: </label>
        <input type="text" id="sceneName" name="sceneName" placeholder="e.g Jungle Exploration" />
        <br />
        <Button variant='contained' id="createSceneButton" type="submit">
          Create Scene
        </Button>
      </form>
      <div className={"scenes"}>
        {scenes.map((item, i) => (
          <div className={"scene"} key={i}>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
}

//,<Track id="DHv55PwhpbQ" name="Calm" scene="Ambient"/>
